import { useState } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于黄瓜种植、品种、病虫害、行情与购种的常见问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="font-heading font-semibold text-foreground-800 text-sm md:text-base pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                  openId === faq.id ? 'rotate-45' : ''
                }`}>
                  <i className={`text-lg transition-colors ${
                    openId === faq.id ? 'ri-close-line text-primary-500' : 'ri-add-line text-foreground-400'
                  }`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openId === faq.id ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}